var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.072,
    height: 47.293,
    viewBox: "0 0 38.072 47.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spade",
    transform: "translate(2.101 2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3896",
    "data-name": "Rectangle 3896",
    d: "M0,0H7.346a0,0,0,0,1,0,0V15.638a3.673,3.673,0,0,1-3.673,3.673h0A3.673,3.673,0,0,1,0,15.638V0A0,0,0,0,1,0,0Z",
    transform: "matrix(-0.799, 0.601, -0.601, -0.799, 17.48, 15.43)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24193",
    "data-name": "Path 24193",
    d: "M444.539,512.586l-16.172,12.17a1.348,1.348,0,0,0,.177,2.266l21.15,11.276a1.347,1.347,0,0,0,1.952-1.469l-4.978-23.446A1.348,1.348,0,0,0,444.539,512.586Z",
    transform: "translate(-417.22 -494.804)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_903",
    "data-name": "Line 903",
    x2: 8.077,
    y2: 10.734,
    transform: "translate(14.69 17.83)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_904",
    "data-name": "Line 904",
    y1: 4.421,
    x2: 5.854,
    transform: "translate(3.899 5.174)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpade);
export default __webpack_public_path__ + "static/media/spade.17856b50c6116d6c9714615f93fdf2a2.svg";
export { ForwardRef as ReactComponent };